import React from 'react'
import { AppBar, Tabs, Tab, Typography, Box } from '@material-ui/core'

import PropTypes from 'prop-types'

import { Container, ContentHeader, Page } from 'components'
import { AccountsData, FinancialData } from './components'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

const AccountsMain = () => {
  const [value, setValue] = React.useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <Page title="Clientes">
      <Container maxWidth={false}>
        <ContentHeader menu="Clientes" title="Listagem" subtitle="Clientes" />
        <div>
          <AppBar
            elevation={0}
            position="static"
            style={{ backgroundColor: 'transparent' }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              position="static"
              indicatorColor="primary"
              textColor="primary"
              style={{ backgroundColor: 'transparent' }}
            >
              <Tab label="Clientes" {...a11yProps(0)} />
              <Tab label="Financeiros" {...a11yProps(1)} />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <AccountsData />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <FinancialData />
          </TabPanel>
        </div>
      </Container>
    </Page>
  )
}

export default AccountsMain
